export default {
    i18next: {
        ns: 'md-search-result'
    },
    props: {
        title: {
            default: ''
        },
        listings: {
            default: []
        },
        snapshotLink: {
            required: true
        },
        count: {
            required: true
        }
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        }
    }
};
